import React, { useState, useEffect } from "react";
import { Card } from "@material-ui/core";
import { useTranslation } from "react-i18next";

import Bar from "../../../../../Component/Charts/Bar";
import config from "../config";

const { chartColors } = config;

const ChecksSource = (props) => {
  const { data = [] } = props;
  const { t } = useTranslation();

  const [series, setSeries] = useState([]);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const local = data.find((s) => s.check_source === "local");
    const localCount = local ? local.no_of_checks : 0;
    const mdm = data.find((s) => s.check_source === "mdm");
    const mdmCount = mdm ? mdm.no_of_checks : 0;
    const dnb = data.find((s) => s.check_source === "dnb");
    const dnbount = dnb ? dnb.no_of_checks : 0;
    if (data && data.length > 0) {
      setSeries([
        {
          data: [
            {
              value: localCount,
              itemStyle: {
                color: chartColors.color2,
              },
            },
            {
              value: mdmCount,
              itemStyle: {
                color: chartColors.color7,
              },
            },
            {
              value: dnbount,
              itemStyle: {
                color: chartColors.color1,
              },
            },
          ],
        },
      ]);
      setCategories([
        t("labels.dashboard.checksBySource.local"),
        t("labels.dashboard.checksBySource.mdm"),
        t("labels.dashboard.checksBySource.d&b"),
      ]);
    }
  }, [data]);

  return (
    <Bar
      title={t("labels.dashboard.checksBySource.title")}
      series={series}
      categories={categories}
    />
  );
};

export default ChecksSource;
